import username from 'flarum/helpers/username';
import highlight from 'flarum/helpers/highlight';
import Avatar from 'flarum/common/components/Avatar';
import LoadingIndicator from 'flarum/components/LoadingIndicator';
export default class UsersSearchResults {
  constructor(props) {
    this.results = {};
    this.searching = false;
    if (!props.state.usersSelected) props.state.usersSelected = [];
    this.usersSelected = props.state.usersSelected;
  }
  search(query) {
    this.searching = true;
    return app.store.find('users', {
      filter: {
        q: query
      },
      page: {
        limit: 5
      }
    }).then(results => {
      this.results[query] = results;
      this.searching = false;
      m.redraw();
    });
  }
  isUserSelected(user) {
    return this.usersSelected.some(u => user.id() == u.id());
  }
  userClick(user) {
    if (!this.isUserSelected(user)) this.usersSelected.push(user);else this.usersSelected.splice(this.usersSelected.indexOf(user), 1);
  }
  view(query) {
    query = query.toLowerCase();
    const usersList = (this.results[query] || []).concat(app.store.all('users').filter(user => [user.username(), user.displayName()].some(value => value.toLowerCase().includes(query)))).filter(user => user !== app.session.user);
    let resultsFind = usersList.filter((e, i, arr) => arr.lastIndexOf(e) === i).sort((a, b) => a.displayName().localeCompare(b.displayName())).filter(user => !this.isUserSelected(user));
    let moreText;
    if (resultsFind.length > 5) {
      moreText = m("div", {
        class: "MoreResultsText"
      }, app.translator.trans('flatrate-live-chat.forum.chat.list.add_modal.search.more_results', {
        more_results: resultsFind.length - 5
      }));
      resultsFind = resultsFind.slice(-5);
    }
    if (!resultsFind.length) {
      if (!this.searching) return m("li", {
        className: "SearchFailed"
      }, app.translator.trans('flatrate-live-chat.forum.chat.list.add_modal.search.failed'));else LoadingIndicator.component({
        size: 'tiny',
        className: 'Button Button--icon Button--link'
      });
    }
    const resultsSelected = Object.values(this.usersSelected).slice(-5);
    return [m("li", {
      className: "Dropdown-header"
    }, app.translator.trans('core.forum.search.users_heading')), resultsFind.map(user => {
      const name = username(user);
      const id = user.id();
      const children = [highlight(name.text, query)];
      return m("li", {
        className: "UserSearchResult UserSearchResult",
        "data-index": 'users' + id,
        onclick: this.userClick.bind(this, user)
      }, m("span", null, m(Avatar, {
        user: user
      }), {
        ...name,
        text: undefined,
        children
      }));
    }), moreText, resultsSelected.length ? m("li", {
      className: "Dropdown-header"
    }, app.translator.trans('flatrate-live-chat.forum.chat.list.add_modal.search.invited')) : null, resultsSelected.map(user => {
      const name = username(user);
      const children = [highlight(name.text, query)];
      return m("li", {
        className: "UserSearchResult UserSearchResult",
        "data-index": 'users' + user.id(),
        onclick: this.userClick.bind(this, user)
      }, m("span", {
        class: "selected"
      }, m(Avatar, {
        user: user
      }), {
        ...name,
        text: undefined,
        children
      }));
    })];
  }
}
flarum.reg.add('flatrate-live-chat', 'forum/components/UsersSearchResults', UsersSearchResults);